import CampaignIcon from '@mui/icons-material/Campaign';
import { classes } from 'constants/common/formConstants'
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CategoryIcon from '@mui/icons-material/Category';
import NotesIcon from '@mui/icons-material/Notes';
import BlockIcon from '@mui/icons-material/Block';
import { danos } from './danos';

export const nearMissForm = (users, disabled, locais) => {
    const styles = { marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }

    return [
        {
            fieldId: 'reportado_por',
            label: 'Reportado por:',
            flex: true,
            required: true,
            disabled,
            type: 'select',
            options: users,
            icon: <PersonIcon style={styles} />
        },
        {
            fieldId: 'local_reporter',
            label: 'Afecto em:',
            flex: true,
            required: true,
            disabled: true,
            type: 'select',
            options: [...locais, { label: "Todos Sites", value: 3 }],
            icon: <LocationOnIcon style={styles} />
        },
        {
            fieldId: 'dataAcontecimento',
            label: 'Data:',
            flex: true,
            required: true,
            disableFuture: true,
            type: 'date',
            width: "203px",
            icon: <CalendarMonthIcon style={styles} />
        },
        {
            fieldId: 'local',
            label: 'Terminal ocorrência:',
            flex: true,
            required: true,
            type: 'select',
            options: locais,
            icon: <LocationOnIcon style={styles} />

        },
        {
            fieldId: 'ondeOcorreu',
            label: 'Onde ocorreu?:',
            placeholder: "De forma resumida, diga o local exacto da ocorrência do evento",
            flex: false,
            type: 'text',
            required: true,
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'descricao',
            label: 'O que aconteceu?:',
            placeholder: "De forma resumida, o que aconteceu?",
            flex: false,
            type: 'text',
            required: true,
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'detalhes',
            label: 'Descrição:',
            placeholder: "Agora podes dar mais detalhes sobre o ocorrido",
            flex: false,
            multiLine: true,
            required: false,
            rows: 4,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'possiveisDanos',
            label: 'O que poderia ter acontecido?',
            flex: false,
            type: 'bubles',
            required: false,
            note: "**Podes clicar em pelo menos uma opção de cada categoria",
            sections: [...danos]
        },
        {
            fieldId: 'classe',
            label: 'Classe do acidene:',
            flex: false,
            required: true,
            type: 'radio',
            options: classes,
            icon: <CategoryIcon style={styles} />
        },
        {
            fieldId: 'medidas_imediatas',
            label: 'Acção Imediata:',
            required: true,
            placeholder: "O que foi que fizeste logo após identificar o near miss?",
            flex: false,
            type: 'text',
            width: "203px",
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'planoDeAccao',
            label: 'Plano de acção:',
            placeholder: "De forma resumida, como podemos resolver isso",
            multiLine: true,
            required: false,
            rows: 4,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'stop_card',
            label: 'Stop card?',
            flex: true,
            required: true,
            radioFlex: true,
            type: 'radio',
            icon: <BlockIcon style={styles} />,
            options: [
                {
                    label: "Sim",
                    value: 1,
                },
                {
                    label: "Não",
                    value: 0,
                }
            ]
        },
        {
            fieldId: 'responsaveis',
            label: 'Responsáveis:',
            required: true,
            flex: true,
            type: 'multiSelect',
            options: users,
            note: "**Ao seleccionar, será notificado por e-mail"
        },
        // {
        //     fieldId: "toNotify",
        //     required: false,
        //     label: "Para conhecimento:",
        //     flex: false,
        //     type: "multiSelect",
        //     options: users,
        //     icon: <CampaignIcon />
        // },

    ]
}